module.exports = __webpack_public_path__ + "media/images/up-arrow-7388fb62221613ca8abd20577a7a9d16.png";